import Logo from "../../components/items/Logo"
import { Link } from "react-router-dom"
import { motion } from "framer-motion"
import AppContext from "../../context/AppContext"
import { useState, useRef, useContext } from "react"

function SignUp() {
  const { goHome } = useContext(AppContext)

  const [form, setForm] = useState({
    institution: '',
    institutionFocus: false,
    email: '',
    emailFocus: false,
    phoneNum: '',
    phoneNumFocus: false,
    address: '',
    addressFocus: false,
    userType: '',
    userTypeFocus: false,
    license: '',
    licenseFocus: false,
    password: '',
    passwordFocus: false,
    password2: '',
    password2Focus: false,
    agreed: false
  })

  const [errors, setErrors] = useState({
    instErr: '',
    emailErr: '',
    phoneErr: '',
    addrErr: '',
    userErr: '',
    licenseErr: '',
    passErr: '',
    pass2Err: '',
    formErr: false
  })

  const {
    instErr,
    emailErr,
    phoneErr, 
    addrErr,
    userErr,
    licenseErr,
    passErr,
    pass2Err,
    formErr
  } = errors

  const {
    institution,
    institutionFocus,
    email,
    emailFocus,
    phoneNum,
    phoneNumFocus,
    address,
    addressFocus,
    userType,
    userTypeFocus,
    license,
    licenseFocus,
    password,
    passwordFocus,
    password2,
    password2Focus,
    agreed
  } = form

  const [allValid, setAllValid] = useState(true)

  const instRef = useRef()
  const emailRef = useRef()
  const phoneRef = useRef()
  const addRef = useRef()
  const licenseRef = useRef()
  const userTypeRef = useRef()
  const passwordRef = useRef()
  const password2Ref = useRef()
  const [showPassword, setShowPassword] = useState(false)
  const [showPassword2, setShowPassword2] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword((value) => !value);
    passwordRef.current.focus();
  }

  const togglePassword2Visibility = () => {
    setShowPassword2((value) => !value);
    password2Ref.current.focus();
  }

  const handleChange = (e) => {
    setForm(values => ({...values, [e.target.id] : e.target.value}))
  }

  const modifyAgreement = () => {
    setForm(values => ({...values, agreed: !values.agreed}))
  } 

  const changeUserType = (e) => {
    setForm(values => ({...values, userType: e.target.value}))
  }

  const resetErrors = () => {
    for(const error in errors){
      setErrors(values => ({...values, [error]: ''}))
    }
    setAllValid(true)
  }

  const resetBorders = () => {
    instRef.current.classList.remove("err")
    emailRef.current.classList.remove("err")
    phoneRef.current.classList.remove("err")
    addRef.current.classList.remove("err")
    userTypeRef.current.classList.remove("err")
    licenseRef.current.classList.remove("err")
    passwordRef.current.classList.remove("err")
    password2Ref.current.classList.remove("err")
  }

  const addError = (errName, err) => {
    setErrors(values => ({...values, [errName]: err}))
  }

  const formError = () => {
    setErrors(values => ({...values, formErr: true}))
    setAllValid(false)
  }

  const isEmail = (value) => {
    // Regular expression for a basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    // Test the value against the regex
    return emailRegex.test(value);
  }

  const validateInputs = () => {
    if(!institution){
      addError("instErr", "Please enter the name of the healthcare institution")
      instRef.current.classList.add("err")
      formError()
    }
    if(!email){
      addError("emailErr", "Please enter a your email address")
      emailRef.current.classList.add("err")
      formError()
    }
    if(email && !isEmail(email)){
      addError("emailErr", "Please enter a valid email address")
      emailRef.current.classList.add("err")
      formError()
    }
    if(!phoneNum){
      addError("phoneErr", "Please enter your phone number")
      phoneRef.current.classList.add("err")
      formError()
    }
    if(!address){
      addError("addrErr", "Please enter the institution's address")
      addRef.current.classList.add("err")
      formError()
    }
    if(!userType){
      addError("userErr", "Please select a type of healthcare provider")
      userTypeRef.current.classList.add("err")
      formError()
    }
    if(!license){
      addError("licenseErr", "Please enter your medical license")
      licenseRef.current.classList.add("err")
      formError()
    }
    if(!password){
      addError("passErr", "Please enter a password")
      passwordRef.current.classList.add("err")
      formError()
    }
    if(!password2){
      addError("pass2Err", "Please confirm your password")
      password2Ref.current.classList.add("err")
    }
    if(password !== password2){
      addError("passErr", "Passwords do not match")
      addError("pass2Err", "Passwords do not match")
      passwordRef.current.classList.add("err")
      password2Ref.current.classList.add("err")
      formError()
    }
  }

  const onSubmit = (e) => {
    e.preventDefault()
    resetErrors()
    resetBorders()
    validateInputs()
    if(allValid){
      console.log("Sending confirmation email")
    }
    
  }

  return (
    <motion.main 
      className="user-form" 
      id="signup"
      initial={{width: 0}}
      animate={{width: '100%'}}
      exit={{x: window.innerWidth, transition: { duration: 0.1 }}}
    >
        <div className='medbolt-logo' onClick={goHome}>
            <Logo/>
        </div>
        <h1>Welcome to Medbolt</h1>
        <p>Kindly fill out your details to get started</p>
        <form className="signup_form" onSubmit={onSubmit} noValidate>
          <p>*indicates required field</p>
          <div>
            <div className="user-input">
              <label style={{color: institutionFocus ? "#486FD8" : "black"}} htmlFor="institution">*Institution/Full name</label>
              <input ref={instRef} type="text" id="institution" required value={institution} onChange={handleChange} 
                onFocus={() => setForm((values) => ({...values, institutionFocus: true}))}
                onBlur={() => setForm((values) => ({...values, institutionFocus: false}))}
                style={{marginBottom: !instErr && '2rem'}}
              />
              {instErr && <div className="error">{instErr}</div>}
            </div>

            <div className="user-input">
              <label style={{color: emailFocus ? "#486FD8" : "black"}} htmlFor="email">*Email</label>
              <input ref={emailRef} type="text" id="email" required value={email} onChange={handleChange}
                onFocus={() => setForm((values) => ({...values, emailFocus: true}))}
                onBlur={() => setForm((values) => ({...values, emailFocus: false}))}
                style={{marginBottom: !emailErr && '2rem'}}
              />
              {emailErr && <div className="error">{emailErr}</div>}
            </div>

            <div className="user-input">
              <label style={{color: phoneNumFocus ? "#486FD8" : "black"}} htmlFor="phoneNum">*Phone Number</label>
              <input ref={phoneRef} type="tel" id="phoneNum" required value={phoneNum} onChange={handleChange} 
                onFocus={() => {setForm((values) => ({...values, phoneNumFocus: true}))}}
                onBlur={() => setForm((values) => ({...values, phoneNumFocus: false}))}
                style={{marginBottom: !phoneErr && '2rem'}}
              />
                {phoneErr && <div className="error">{phoneErr}</div>}
            </div>

            <div className="user-input">
              <label style={{color: addressFocus ? "#486FD8" : "black"}} htmlFor="address">Address</label>
              <input ref={addRef} type="text" id="address" value={address} onChange={handleChange} 
                onFocus={() => setForm((values) => ({...values, addressFocus: true}))}
                onBlur={() => setForm((values) => ({...values, addressFocus: false}))}
                style={{marginBottom: !addrErr && '2rem'}}
              />
              {addrErr && <div className="error">{addrErr}</div>}
            </div>

            <div className="user-input">
              <label style={{color: userTypeFocus ? "#486FD8" : "black"}} htmlFor="userType">Type of User</label>
              <select ref={userTypeRef} onChange={changeUserType} name="userType" id="userType" value={userType}
                onFocus={() => setForm((values) => ({...values, userTypeFocus: true}))}
                onBlur={() => setForm((values) => ({...values, userTypeFocus: false}))}
                style={{marginBottom: !userErr && '2rem'}}
              >
                <option value="">Please select an option</option>
                <option value="hospital">Hospital</option>
                <option value="pharmacy">Pharmacy</option>
                <option value="laboratory">Laboratory</option>
              </select>
              {userErr && <div className="error">{userErr}</div>}
            </div>

            <div className="user-input">
              <label style={{color: licenseFocus ? "#486FD8" : "black"}} htmlFor="license">Medical License No</label>
              <input ref={licenseRef} type="text" id="license" value={license} onChange={handleChange}
                onFocus={() => setForm((values) => ({...values, licenseFocus: true}))}
                onBlur={() => setForm((values) => ({...values, licenseFocus: false}))}
                style={{marginBottom: !licenseErr && '2rem'}}
              />
              {licenseErr && <div className="error">{licenseErr}</div>}
            </div>
            <div className="user-input">
              <label style={{color: passwordFocus ? "#486FD8" : "black"}} htmlFor="password">*Password</label>
              <div id="pass">
                <input ref={passwordRef} type={showPassword ? "text" : "password"} id="password" required value={password} onChange={handleChange}
                  onFocus={() => setForm((values) => ({...values, passwordFocus: true}))}
                  onBlur={() => setForm((values) => ({...values, passwordFocus: false}))}
                  style={{marginBottom: !passErr && '2rem'}}
                />
                <span className="eye" title={showPassword ? "hide password" : "show password"} onClick={togglePasswordVisibility}>{!showPassword ? <i className="fa-regular fa-eye"></i> : <i className="fa-regular fa-eye-slash"></i>}</span>
                {passErr && <div className="error">{passErr}</div>}
              </div>
            </div>
            <div className="user-input">
              <label style={{color: password2Focus ? "#486FD8" : "black"}} htmlFor="password2">*Confirm Password</label>
              <div id="pass">
                <input ref={password2Ref} type={showPassword2 ? "text" : "password"} id="password2" required value={password2} onChange={handleChange}
                  onFocus={() => setForm((values) => ({...values, password2Focus: true}))}
                  onBlur={() => setForm((values) => ({...values, password2Focus: false}))}
                  style={{marginBottom: !pass2Err && '2rem'}}
                />
                <span className="eye" title={showPassword2 ? "hide password" : "show password"} onClick={togglePassword2Visibility}>{!showPassword2 ? <i className="fa-regular fa-eye"></i> : <i className="fa-regular fa-eye-slash"></i>}</span>
                {pass2Err && <div className="error">{pass2Err}</div>}
              </div>
            </div>

            <p className="small">Create a password of 8-25 characters long that include at least 1 upper case and 1 lower case letter, 1 number and 1 special character like $,%,&,”, etc</p>
            <h5>TERMS OF USE</h5>
            <div className="terms">
              <div>
                <input onChange={modifyAgreement} type="checkbox" checked={agreed} id="agree"/>
              </div>
              <label htmlFor="agree">I agree to the <Link className="link">Terms of use</Link> and <Link className="link">Privacy policy</Link> of Medbolt AI Solutions</label>
            </div>
          </div>
          <button className="trynow">Sign up</button>
          {formErr &&<p className="error">Please fill out the form correctly</p>}
          {!agreed &&<p className="error">Please agree to the Terms continue</p>}
          <p className="signin_text">Already have an account? <Link className="link" to="/login">Sign in</Link></p>
        </form>

    </motion.main>
  )
}

export default SignUp